import { StrictMode, Fragment } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App'
import {
  JOIN_BASENAME, HOME_BASENAME, isJoinPathMount, isHomePathMount,
} from '@/lib/site'

const Wrapper = import.meta.env.DEV ? StrictMode : Fragment

// The path mounts (/join, /home) run the public sites without their own
// hostname; on the real hostnames the router owns the root.
const basename = isJoinPathMount
  ? JOIN_BASENAME
  : isHomePathMount
    ? HOME_BASENAME
    : undefined

createRoot(document.getElementById('root')!).render(
  <Wrapper>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </Wrapper>,
)
